// import { createTheme } from "@mui/material/styles";

// export const restaurantThemes = {
//   "Snack & Shake": createTheme({
//     palette: {
//       primary: {
//         main: "#1976d2",
//       },
//       secondary: {
//         main: "#4fc3f7",
//       },
//       background: {
//         default: "#e3f2fd",
//         paper: "#bbdefb",
//       },
//     },
//   }),
//   "Chai bunk": createTheme({
//     palette: {
//       primary: {
//         main: "#5d4037",
//       },
//       secondary: {
//         main: "#8d6e63",
//       },
//       background: {
//         default: "#efebe9",
//         paper: "#d7ccc8",
//       },
//     },
//   }),
//   Waffles: createTheme({
//     palette: {
//       primary: {
//         main: "#2e7d32",
//       },
//       secondary: {
//         main: "#66bb6a",
//       },
//       background: {
//         default: "#e8f5e9",
//         paper: "#c8e6c9",
//       },
//     },
//   }),
// };

import { createTheme } from "@mui/material/styles";

export const restaurantThemes = {
  "Snack & Shake": createTheme({
    palette: {
      primary: {
        main: "#42a5f5",
      },
      secondary: {
        main: "#81d4fa",
      },
      background: {
        default: "#eaf4fb",
        paper: "#cfe8fc",
      },
    },
  }),
  "Chai bunk": createTheme({
    palette: {
      primary: {
        main: "#fbc02d",
      },
      secondary: {
        main: "#000000",
      },
      background: {
        default: "#fffde7",
        paper: "#ffecb3",
      },
      text: {
        primary: "#000000",
        secondary: "#fbc02d",
      },
    },
  }),
  Waffles: createTheme({
    palette: {
      primary: {
        main: "#6d4c41",
      },
      secondary: {
        main: "#a1887f",
      },
      background: {
        default: "#efebe9",
        paper: "#d7ccc8",
      },
      text: {
        primary: "#3e2723",
        secondary: "#5d4037",
      },
    },
  }),
};
